/* Display-only dispatch information; existing Dawn section updates supply context. */
(() => {
  // Berlin is on CET on this date. This instant is independent of visitor timezone.
  const endsAt = Date.parse('2026-11-03T00:00:00+01:00');
  const maxTimeout = 60_000;

  class IstarDispatchWindow extends HTMLElement {
    constructor() {
      super();
      this.refresh = this.refresh.bind(this);
    }

    connectedCallback() {
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
      this.refresh();
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
      clearTimeout(this.timer);
    }

    refresh() {
      clearTimeout(this.timer);
      const remaining = endsAt - Date.now();
      this.updateDisplay(remaining > 0);
      if (remaining > 0) {
        // A short bound also corrects visibility after a device-clock adjustment.
        this.timer = setTimeout(this.refresh, Math.min(remaining, maxTimeout));
      }
    }
  }

  if (!customElements.get('istar-dispatch-notice')) {
    customElements.define('istar-dispatch-notice', class extends IstarDispatchWindow {
      static get observedAttributes() { return ['data-requires-shipping']; }

      attributeChangedCallback() {
        if (this.isConnected) this.refresh();
      }

      updateDisplay(active) {
        this.hidden = !active || this.getAttribute('data-requires-shipping') !== 'true';
      }
    });
  }

  if (!customElements.get('istar-dispatch-banner')) {
    customElements.define('istar-dispatch-banner', class extends IstarDispatchWindow {
      updateDisplay(active) {
        const original = this.querySelector('[data-istar-original]');
        const temporary = this.querySelector('[data-istar-temporary]');
        if (!original || !temporary) return;
        original.hidden = active;
        temporary.hidden = !active;
      }
    });
  }
})();
